// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as PaymentsActions } from '../duck';
import Payments from '../components/Payments';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isPostingPayment: state.preferences.payments.isPostingPayment,
    isPuttingPayment: state.preferences.payments.isPuttingPayment,
    isDeletingPayment: state.preferences.payments.isDeletingPayment,
    payments: state.preferences.payments.payments,
    closePaymentModal: state.preferences.payments.closePaymentModal,
    successDelete: state.preferences.payments.successDelete,
    postPaymentError: state.preferences.payments.postPaymentError,
    putPaymentError: state.preferences.payments.editPaymentError,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(PaymentsActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Payments);



// WEBPACK FOOTER //
// ./src/modules/preferences/payments/containers/PaymentsContainer.js